import { render, staticRenderFns } from "./JobMaterialList.vue?vue&type=template&id=b25415bc&scoped=true&"
import script from "./JobMaterialList.vue?vue&type=script&lang=ts&"
export * from "./JobMaterialList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25415bc",
  null
  
)

export default component.exports